<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="foreword" id="_idContainer005" role="doc-foreword">
<p class="pl-epigraph">Live in harmony with one another; be sympathetic, love as brothers, be compassionate and humble. </p>
<p class="pl-citation">—<em class="italic">1 Peter </em><span class="roman">3:8</span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Bible_Verse.vue?2d37773c